import {
  EmergencyScenarioAccessPointFiltersInput,
  EmergencyScenarioAccessPointTableFragment,
} from '../../graphql/api/generated';
import { PermissionKey_enum } from '../../graphql/hasura/generated';
import { Model } from '../Model';

export const EmergencyScenarioAccessPointModel = new Model<
  EmergencyScenarioAccessPointFiltersInput,
  EmergencyScenarioAccessPointTableFragment
>({
  names: {
    schemaName: 'EmergencyScenarioAccessPoint',
  },
  permissionsOptions: {
    // Bypass introspection check (queries will be made to Main API rather than Hasura)
    canRead: ({ hasPermission }) => hasPermission(PermissionKey_enum.EmergencyScenario_Read),
  },
});

export default EmergencyScenarioAccessPointModel;
